import { render, staticRenderFns } from "./ManualOffer.vue?vue&type=template&id=b3afbe20"
import script from "./ManualOffer.vue?vue&type=script&lang=ts"
export * from "./ManualOffer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports